module.exports = __webpack_public_path__ + "static/media/google_play_badge_ru_color_40.68404de8.svg";